<template>
  <div style="background: transparent; padding: 0px; padding-top: 0px; overflow: auto; max-height: 80vh; width: 100%; height: 100%;overflow:hidden;">
    <div style="background: transparent; color: yellow; padding: 0px">
      <b-row>
        <b-col cols="4">
          <!-- <b-button @click="clearMeasuresFromStore" :disabled="!this.$store.state['workLists'].taskRecords[61]" type="button" variant="primary-green" size="sm" style="margin-right: 10px;">
						<span>Clear Measures</span>
					</b-button> -->

          <!-- <span v-if="AreIdsShown">getContractMeasuresFilters {{ getContractMeasuresFilters.length }}</span> -->
        </b-col>
        <b-col cols="6" style="height: 100%">
          <!-- <h4> BUILD ContractMeasuresFilters</h4> -->
          <!-- props.providerNameList {{ props.providerNameList }} -->

          <ContractMeasuresFilters :providerNamesList="props.providerNameList" />
          <!-- getContractMeasuresFilters
					{{ getContractMeasuresFilters }}-->
          <!-- <ContractMeasuresFilters   :providerNamesList="searchTerms" @userSelectedProvider="updateTagFilter" /> -->
        </b-col>
        <b-col v-if="HideTagButtons" cols="*">
          <h3>props.records {{ props.records?.length }}</h3>
          <br />

          <!-- <h6>Providers: </h6> -->
          <b-form-tags v-model="props.providerNameList" no-outer-focus class="mb-0" tag-variant="dark-green" style="background: darkred; padding: 10px" tag-pills size="sm">
            <template v-slot="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
              <b-input-group aria-controls="my-custom-tags-list">
                <!-- <b-form-input v-bind="inputAttrs"
								v-on="inputHandlers" type="search" id="dx-term" size="sm" v-model="searchTerm" placeholder="DX Code Search Term" required></b-form-input>-->
                <!-- <input
										v-bind="inputAttrs"
										v-on="inputHandlers"
										placeholder="New tag - Press enter to add"
										class="form-control">
										<b-input-group-append>
											<b-button @click="addTag()" variant="primary">Add</b-button>
								</b-input-group-append>-->
              </b-input-group>
              <div
                style="background: transparent; padding: 0px"
                id="my-custom-tags-list"
                class="list-unstyled d-inline-flex flex-wrap mb-0"
                aria-live="polite"
                aria-atomic="false"
                aria-relevant="additions removals"
              >
                <!-- Always use the tag value as the :key, not the index! -->
                <!-- Otherwise screen readers will not read the tag
								additions and removals correctly-->
                <!-- tags {{ tags.length }} -->
                <div v-for="tag in tags" :key="tag" :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`" tag="li" class="mt-0 mr-0" body-class="py-0 pr-0 text-nowrap">
                  <b-button @click="showTagINFO(tag)" size="sm">{{ tag }}</b-button>
                  <button aria-keyshortcuts="Delete" type="button" aria-label="Remove tag" variant="danger" class="close b-form-tag-remove" @click="removeTag(tag)" size="sm">×</button>
                  <!-- <button
													@click="removeTag(tag)"
													class="close b-form-tag-remove"
													variant="link"
													size="sm"
													:aria-controls="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
									>xXx</button>-->
                </div>
              </div>
            </template>
          </b-form-tags>
        </b-col>
      </b-row>
    </div>

    <div v-if="AreIdsShown" style="max-height: 90px; overflow: auto">
      <span class="d-flex justify-content-start">
        <li v-for="item in recordsSelected" :key="item.id">
          Id: {{ item.id }} | contractMeasureID: {{ item.contractMeasureID }} | contractMeasureDetails: {{ item.contractMeasureDetails.length }}
          <br />
          <div class="col" style="margin-left: 15px; max-height: 50px; overflow: auto">
            <!-- childItem in item.messageComments" -->

            <span class="d-flex justify-content-end" style="background: black; color: cyan" v-for="childItem in item.contractMeasureDetails" :key="childItem.id">
              <li>{{ childItem.id }} {{ childItem.lastName }} {{ childItem.firstName }}</li>
            </span>
          </div>

          <!-- <li v-for="item in selectedCOMMs" :key="item.id">
					<span v-for="childItem in item.messageComments">
						{{ childItem.comment }} {{ childItem }}
					</span>
					</li>-->
        </li>
      </span>
    </div>

    <!-- <h2 v-if="AreIdsShown" style="background:lime;color:red;">DASH MEASURES record selector </h2> -->
    <!-- recordsSelected:	{{ recordsSelected.length}} -->
    <!-- {{ recordsSelected.contractMeasureID }} -->

    <span v-if="AreIdsShown" style="color: cyan; background: darkblue"> records {{ props.records?.length }} localRecords {{ localRecords?.length }}</span>

    <slot :recordsSelected="recordsSelected"></slot>

    <DxDataGrid
      class="patientMeasuresTasksGrid"
      :show-borders="true"
      height="100%"
      width="100%"
      :data-source="props.records"
      :row-alternation-enabled="false"
      :hover-state-enabled="true"
      :column-auto-width="true"
      :focused-row-enabled="true"
      :word-wrap-enabled="false"
      :ref="dataGridRefName"
      :key-expr="idField"
      :columns="props.fields"
      @row-prepared="onRowPrepared"
      @row-expanding="onRowExpanding"
      noDataText="No Records were found ........"
          @row-click="onRowClick"
    >
      <dx-search-panel :visible="false" />
      <DxPaging :enabled="true" :pageSize="50" />
      <!-- <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" /> -->

      <DxFilterRow :visible="false" />
      <DxHeaderFilter :visible="false" />
      <DxLoadPanel :enabled="true" />
      <!-- <DxMasterDetail :enabled="true" template="details" :auto-expand-all="false" /> -->
      <!-- <div slot="details" class="detailsSlot">
					<DetailTemplate :templateData="record"/>
			</div>-->
      <DxMasterDetail :enabled="true" template="detailTemplate" :auto-expand-all="false" />
      <template #detailTemplate="{ data: customers }">
        <div class="detailGrid-info">
          <DetailTemplate :selectedFileName="customers.data.contractMeasureFileName" :templateData="customers.data.contractMeasureDetails" :handleOnCellPrepared="handleNULLDateDASH" />
          <!-- <p  v-if="AreIdsShown" class="employee-notes">customers.data : {{ customers.data }}</p> <br>
					<p  v-if="AreIdsShown" class="employee-notes"> contractMeasureDetails : {{ customers.data.contractMeasureDetails }}</p><br>
					<p v-if="AreIdsShown"  class="employee-notes">{{ customers.data.contractMeasureFileName }}</p> -->
        </div>
      </template>
      <!-- <dx-export
        :enabled="true"
        :allow-export-selected-data="true"
        :file-name="exportName"
      />
      <dx-search-panel
        :visible="true"
        :highlight-case-sensitive="true"
			/>-->
      <!-- <div slot="lastName" slot-scope="{ data }">
				<router-link tag="a" :to="`/Patient/${data.data.personId}`">{{ data.data.lastName }}</router-link>
			</div>
			<div slot="firstName" slot-scope="{ data }">
				<router-link tag="a" :to="`/Patient/${data.data.personId}`">{{ data.data.firstName }}</router-link>
			</div>-->
      <!-- <template #delegationItem="{ data }"> -->
      <!-- <create-new-delegation @create-delegation-done="onDelegationDone" :recordIds="recordIds" :sourceId="sourceId" :disabled="recordActionButtonsDisabled" /> -->
      <!-- </template> -->
      <!-- <template #filterItem="{ data }">
			<div class="filter-form">-->
      <!-- <b-form-group label-cols="5" label="Type of Work Filter:" label-for="filter-select">
						<b-form-select @change="onSelectedFilter" id="filter-select" v-model="activeFilter" :options="filterOptions"></b-form-select>
			</b-form-group>-->
      <!-- </div>
			</template>-->
      <!-- <template #formatDate-template="{ data }">
				<span>{{ formatDate(data.text) }}</span>
			</template>-->
    </DxDataGrid>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
// * STOREs
import { useStoreWorkList } from "@/stores/workListsStore";
const workListStore = useStoreWorkList();

// & COMPOSIBLEs
import { useFormatDate } from "@/use/formatDate.js";

import ContractMeasuresFilters from "@/components/ContractMeasuresFilters.vue";

import DetailTemplate from "./DetailTemplate.vue";

import {
  DxDataGrid,
  DxColumn,
  DxButton,
  DxPager,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLoadPanel,
  DxHeaderFilter,
  DxGroupPanel,
  DxGrouping,
  DxSearchPanel,
  DxMasterDetail,
  DxSelection,
  // DxButton,
  // DxExport,
  // DxColumnFixing,
  DxScrolling,
} from "devextreme-vue/data-grid";

// & PROPS
const props = defineProps({
  records: {
    Type: Array,
    Default: () => {},
  },
  fields: {
    Type: Array,
    Default: () => {},
  },
  idField: {
    Type: String,
    Default: () => {},
  },
  idCat: {
    Type: String,
    Default: () => {},
  },
  idTestId: {
    Type: String,
    Default: () => {},
  },
  selected: {
    Type: Array,
    Default: () => {},
  },
  handleOnCellPrepared: {
    Type: Function,
    Default: () => {},
  },
  FromLabs: {
    Type: Boolean,
    Default: () => {},
  },
  FromVitals: {
    Type: Boolean,
    Default: () => {},
  },
  FromIMMZ: {
    Type: Boolean,
    Default: () => {},
  },
  sourceId: {
    Type: String,
    Default: () => {},
  },
  isMeasures: {
    Type: Boolean,
    Default: () => {},
  },
  providerNameList: {
    Type: Array,
    Default: () => {},
  },
});

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(false);
const HideTagButtons = ref(false);
const localRecords = ref([]);

function showTagINFO(tag) {
  // //console.clear()()

  // console.log(" >> 	showTagINFO					");
  // console.log(" >> 		BIND			 this.records = this.allMyMeasures	");
  props.records.value = workListStore.allMyMeasures;
  // console.log(" >> SHOW TAG INFO");
  // console.log("props.records.value");
  // console.log(props.records.value);
  // console.log(" >>                FILTER >>  tag");
  // console.log(tag);
  // toastrSuccess(' SUBMITTING    Word :   ' + tag)
  // const found = this.records.some((r) => this.providerNameList.includes(r.providerName))
  // console.log(' found :')

  if (tag !== null) {
    const fPersonWorkType = workListStore.allMyMeasures.filter(function (person) {
      // console.log("person");
      // console.log(person);
      // console.log(tag);
      // console.log("person.providerName");
      // console.log(person.providerName);
      return person.providerName === tag;
    });

    // console.log("		fPersonWorkType");
    // console.log(fPersonWorkType);

    localRecords.value = fPersonWorkType;

    return localRecords;

    // console.log('	FILL THIS		props.records.value')
    // console.log(	props.records.value)

    // return props.records.value
  } else {
    props.records = workListStore.allMyMeasures;
  }

  // console.log(fPersonWorkType)
  // return fPersonWorkType

  // const dTask = this.records.filter((patient) => this.providerNameList.includes(patient.providerName))
  //   console.log('   dTask: ', dTask)

  // this.searchTerm = e
  // this.onSubmit(this.searchTerm )
}

function handleNULLDateDASH(e) {
  // //console.clear()()
  // console.log(" handleNULLDateDASH TARGET test");
  e.cellElement.style.color = "yellow";
  e.cellElement.style.backgroundColor = "darkred";

  if (e.text === "01/01/0001" || e.text === "1/1/1901" || e.text === "1/1/1900" || e.text === "12/31/1900" || e.text === "01/01/0001") {
    // console.log(e.text = ' DATE MATCH &&&&')
    e.column.minWidth = 20;
    e.column.width = 70;
    e.text = " DATE MATCH &&&&";
    e.displayValue = " DATE MATCH &&&&";
    e.value = " ";
    // e.cellElement.style.color = 'yellow'
    // e.cellElement.style.backgroundColor = 'darkred'
    e.value = " ``` ";
    e.cellElement.innerText = e.value;
  }
  // console.dir(e.data)
  // console.log('E DATA: ')
  if (e.column.dataField === "actualYTD") {
    // e.cellElement.style.color = 'green'
    // e.cellElement.style.backgroundColor = 'yellow'
    // e.column.format = 'percent'
  }
  // console.log(e.data.contractMeasureID)
  // console.log('Act YTD: ' + e.data.actualYTD)
  // console.log('needed: ' + e.data.neededForTarget)
  // if (e.data.contractMeasureID >= 0) { e.cellElement.style.backgroundColor = 'red'}

  // if (e.rowElement.dataField === 'contractMeasureID') {
  // 	console.log(' >>>>>>>>>>>>> dfsdf')
  // 	// e.cellElement.style.backgroundColor = 'blue'
  // }
  if (e.column.measureStatus !== null || e.data.measureStatus !== "undefined") {
    if (e.data.measureStatus === "1") {
      e.cellElement.style.backgroundColor = "#e7caca";
    } else if (e.data.measureStatus === "2") {
      e.cellElement.style.backgroundColor = "#fbe7b7 ";
    } else if (e.data.measureStatus === "3") {
      e.cellElement.style.backgroundColor = "#b6fce3";
    }
  }

  //else
  // if (e.data.actualYTD > e.data.neededForTarget) {
  // e.cellElement.style.backgroundColor = 'darkgoldenrod'
  //}
  // else if (e.data.neededForTarget === 30){ 				e.cellElement.style.backgroundColor = 'darkblue'}
  // else if (e.data.neededForTarget >= 50){ 				e.cellElement.style.backgroundColor = 'darkgoldenrod'}
  if (e.columnIndex === 1) {
    // console.log('E : ')
    // console.dir(e)
    // //console.clear()()
    // console.log(' col Indx 1')
    // console.dir(e.column)

    // console.log(" dataField : ");
    // console.dir(e.column.dataField)
    e.column.visible = false;
  }

  if (e.column.dataField === "contractMeasureName") {
    // e.cellElement.style.color = '#e3f4e5'
    // e.cellElement.style.backgroundColor = '#6e796f'
    e.column.width = "auto";
  }
  if (e.column.dataField === "eligible") {
    // e.cellElement.style.color = 'cyan'
    // e.cellElement.style.backgroundColor = 'blue'
  }

  if (e.text === "0001-01-01T06:00:00Z" || e.text === "0001-01-01T06:00:00Z") {
    // // c		e.cellElement.style.color = 'yellow'
    e.cellElement.style.backgroundColor = "darkred";
    // console.log((e.text = " DATE MATCH 12/31/2099"));
    e.column.minWidth = 20;
    e.column.width = 70;
    e.text = " DATE MATCH &&&&";
    e.displayValue = " DATE MATCH &&&&";
    e.value = " ";

    e.value = " ``` ";
    e.cellElement.innerText = e.value;
  }

  // console.log("      handleNULLDATEsValue(e) ", e);
  if (e.columnIndex === 13 || e.columnIndex === 110) {
    // e.cellElement.style.color = 'yellow'
    // e.cellElement.style.backgroundColor = 'darkred'

    if (e.text === "0001-01-01T06:00:00Z") {
      // // c		e.cellElement.style.color = 'yellow'
      e.cellElement.style.backgroundColor = "darkred";
      // console.log((e.text = " DATE MATCH 12/31/2099"));
      e.column.minWidth = 20;
      e.column.width = 70;
      e.text = " DATE MATCH &&&&";
      e.displayValue = " DATE MATCH &&&&";
      e.value = " ";

      e.value = " ``` ";
      e.cellElement.innerText = e.value;
    }
    if (e.text === "2099-12-31T06:00:00Z") {
      // // console.log(e.text = ' DATE MATCH 12/31/2099')
      e.column.minWidth = 20;
      e.column.width = 70;
      e.text = " DATE MATCH &&&&";
      e.displayValue = " DATE MATCH &&&&";
      e.value = " ";

      e.value = " ``` ";
      e.cellElement.innerText = e.value;
    }

    //1/1/1900
    if (e.text === "1/1/1901" || e.text === "1/1/1900" || e.text === "12/31/1900" || e.text === "01/01/0001") {
      // console.log(e.text = ' DATE MATCH &&&&')
      e.column.minWidth = 20;
      e.column.width = 70;
      e.text = " DATE MATCH &&&&";
      e.displayValue = " DATE MATCH &&&&";
      e.value = " ";
      // e.cellElement.style.color = 'yellow'
      // e.cellElement.style.backgroundColor = 'darkred'
      e.value = " ``` ";
      e.cellElement.innerText = e.value;
    }
  }
}

function onRowPrepared(e) {
  // console.clear()
  // console.log("__________________onRowPrepared_______________");
  // console.log(" start  E: ");

  // console.dir(e);

  // let colCONT = e.columns.forEach((col) => { // // console.log(col.name)})
  // console.log('														______________________rowElement........')
  const rowElement = e.rowElement;
  // console.dir(rowElement);

  rowElement.style.cursor = "pointer";
  const record = e.data;

  // console.log("record........");

  // console.dir(record);
  // console.log('RecordID: ' + record.id)
  //
  if (!record) return; // this is probably a header or footer row and thus doesn't have the data property
  if (record.complient === "Y") {
    rowElement.style.backgroundColor = "#849185";
    // rowElement.style.color = "#dcf1de";
    rowElement.style.fontWeight = 900;
  } else if (record.complient === "N") {
    rowElement.style.backgroundColor = "#D14E4E";
    // <!-- rowElement.style.color = "#dcf1de"; -->
    rowElement.style.fontWeight = 900;

    // & ADD CLASS to ROW
    // rowElement.classList.add('testClass')
  }

  // * NEW
  // console.clear();
  // console.log(" MEASURE STATUS  from record");
  // console.log(record.measureStatus);
  // console.log(" MEASURE STATUS  from rowElement");
  // console.dir(rowElement);

  // &* NEW  0528;
  // console.log(" modalTheme.value: ", modalTheme.value);

  // Measure status coloring with modal theme
  if (record.measureStatus === "1") {
    if (modalTheme.value.includes("generic-light")) {
      rowElement.style.backgroundColor = "#e7caca";
      rowElement.style.color = "#123486";
    } else if (modalTheme.value.includes("generic-dark")) {
      rowElement.style.backgroundColor = "#6a2323";
      rowElement.style.color = "#DCF1DE";
    }
  } else if (record.measureStatus === "2") {
    if (modalTheme.value.includes("generic-light")) {
      rowElement.style.backgroundColor = "#fbe7b7";
      rowElement.style.color = "#123486";
    } else if (modalTheme.value.includes("generic-dark")) {
      rowElement.style.backgroundColor = "#66512c";
      rowElement.style.color = "#DCF1DE";
    }
  } else if (record.measureStatus === "3") {
    if (modalTheme.value.includes("generic-light")) {
      rowElement.style.backgroundColor = "#b6fce3";
      rowElement.style.color = "#123486";
    } else if (modalTheme.value.includes("generic-dark")) {
      rowElement.style.backgroundColor = "#2e6033"; // "#35853d"; // "#1e3120";
      rowElement.style.color = "#DCF1DE";
    }
  }

  e.columns.forEach((col) => {
    if (col.index > 0) {
      // // // console.log(' index > 0')
      // // // console.log(col.index)
      //	string.match(/^\([0-9]+\)/)
      // // // console.log(col)
      // if (col.caption.match(/^\d/)) {
      // 	toastrSuccess(' 		NUYMBER .............')
      // 	// // console.log(col.name)
      // }
      // if (col.caption.match(/^\d/)) {
      // 	// Return false
      // 	// toastrError(' 		not .............')
      // 	// // console.log(' name: ', col.name)
      // 	// // console.log(' caption: ', col.caption , ' width: ', col.width)
      // 	// // console.log(' dataField: ', col.dataField)
      // }
      // // // console.log(col.caption)
      // var patt = new RegExp(/^\d/)
      // // // console.log('PATT')
      // // // console.log(patt.test(col.name))
      // if (patt.test(col.name)) {
      // 	toastrInfo(' 		NUYMBER .............')
      // }
      // 	if (col.name.match(/^\d/)) {
      // 	// // console.log('IS N UMBER    col.name :', col.name)
      // }
      // col.width = 230
    }
    // else 	if (col.caption !== 'Measurement') {
    // 		e.rowElement.bgColor = 'blue'
    // 		col.width = 10
    // }

    // if (col.name === 'description') {
    // 	if (s.match(/^\d/)) {
    // 		// Return true
    // 	}
    // }
    if (props.FromIMMZ) {
      // // console.log('  FROM    IMM Z ')
      if (col.caption === "Comment") {
        // col.width = 'auto'
      }
    }
    if (props.FromLabs || props.FromVitals || props.FromIMMZ) {
      // // // console.log('  FROM LABs ')
      if (col.name === "description") {
        // e.rowElement.cells[2].bgColor = 'transparent'
        // e.rowElement.cells[2].style.color = 'red'

        col.width = 220;
      } else {
        // e.rowElement.cells[3].bgColor = 'darkred'
        // e.rowElement.cells[3].style.color = 'pink'
        // // // console.log(e.rowElement.cells[3])
        col.width = 30;
        //col.alignment='center'
        if (col.name === "testName") {
          // // // console.log('_________________________________')
          // // // console.log('COLUMN')

          // // // console.log('NAME: ' + col.name)
          // // // console.log(' testName > E: rowElement')
          // // // console.dir(e.rowElement)
          // // // console.log('_________________________________')

          // e.rowElement.cells[1].bgColor = 'transparent'
          // e.rowElement.cells[1].style.color = 'blue'

          if (col.minWidth === 80) {
            // // // console.log('FOUND 80')
            // e.rowElement.cells[1].bgColor = 'red'
            // e.rowElement.cells[1].style.color = 'white'
            // e.rowElement.cells[1].style.width = '20'
            col.width = 250;
            // e.rowElement.cells[2].width = 450
            //col.minWidth = 30
            //e.rowElement.cells[1].width = '20'
          }
        }
      }
    }

    // if (col.caption === 'Measurement') {
    // 	// // console.log('col.name :', col.name)
    // 	// // console.log('col.dataField :', col.dataField)

    // 	e.column[0].width = 100
    // 	e.rowElement.cells[0].style.backgroundColor = 'blue'
    // 	e.rowElement.cells[1].style.color = 'red'

    // 	if (col.name === 'description') {
    // 		// e.rowElement.cells[2].bgColor = 'transparent'
    // 		// e.rowElement.cells[2].style.color = 'red'
    // 		//  e.rowElement.cells[1].style.color = 'red'
    // 		// e.rowElement.cells[1].style.color = 'red'
    // 		col.width = 620
    // 	} else {
    // 		// e.rowElement.cells[2].style.backgroundColor = 'blue'
    // 		col.width = 30
    // 	}
    // }
    // 								{
    // 									// // //console.clear()()

    // 									// // console.log(col)

    // 									col.minWidth = '10'

    // 									// // console.log('E: rowElement')

    // 									// // console.dir(e.rowElement)

    // //									e.rowElement.bgColor = 'green'
    // 									//e.rowElement.style.backgroundColor = 'blue'
    // 									 e.rowElement.style.color = 'black'
    // 									 e.rowElement.width = '50'
    // 									 e.rowElement.align = 'left'

    // 									// & ADD CLASS to ROW
    // 									// e.rowElement.classList.add('testClass')
    // 								}
    // 								else
    // 								{
    // 									e.rowElement.bgColor = 'darkorange'
    // 									e.rowElement.style.color = 'yellow'
    // 									 e.rowElement.style.align = 'center'
    // 									 e.rowElement.width = '30'
    // 									 e.rowElement.align = 'center'
    // 								}
    // // // console.log('end...')
    // 	}
  });

  // // 	// // // console.log('col.name : ', col.name)

  //   if (col.name === 'Test Name') {
  // 		// // console.log(' found   Test Name')
  // 		// rowElement.style.backgroundColor = 'red'
  // 		// rowElement.style.color = 'yellow'
  //   }
  //   // this.filterOptions.push({ text: item.label, value: item.value })
  // })
}

async function onRowExpanding(e) {
  // console.log("row exp        onRowExpanding ");
  // console.log("	Get PersionID:  on ROW Exanding ");

  e.component.collapseAll(-1);
}
async function onRowClick(e) {
// console.log("onRowClick");
// console.log(e);
  // console.log("e.key");
  // console.log(e.key);
  // console.log("e.data");
  // console.log(e.data);

    //  Check if the click was on the expand/collapse cell
  if (e.event?.target?.closest(".dx-command-expand")) {
    // Let DevExtreme handle the expand/collapse
    return;
  }

  const dataGridInstance = e.component;
  if (e.isExpanded) {
    dataGridInstance.collapseRow(e.key);
  } else {
    dataGridInstance.expandRow(e.key);
  }
}
onMounted(() => {
  // console.log("onMounted() :      DashMeasuresRecordSelector >>>>");

  // console.log("props : ");
  // console.log(props);
  // console.log(" prop   records.value");
  // console.log(props.records.value);
  // console.log(" prop _________________________________________");

  localRecords.value = props.records;

  // console.log(" 											localRecords ");
  // console.log(localRecords);

  // console.log(" prop   fields ");
  // console.log(props.fields);
  // console.log(" prop   providerNameList ");
  // console.log(props.providerNameList);

  // console.log(" prop   handleOnCellPrepared ");
  // console.log(props.handleOnCellPrepared);

  // console.log(" prop   sourceId ");
  // console.log(props.sourceId);
});
</script>

<style lang="scss" scoped>
a {
  text-decoration: underline;
}

.page-grid-wrapperDEVex {
  background-color: #c6d9c8;

  // padding: 10px 10px 10px 10px;
  //  width: 30em;
  // max-height: 750px;
  // overflow-y: auto;
  // overflow-x: auto;
  // white-space: nowrap;
  // max-width:1314px;
  background: yellow; // #b0c1b2;
  //	background: transparent;
  //	width: 100% !important;
  padding: 6px;
  //0padding: $diet-padding;
  //max-height: 830px;wrapper
}

.detailGrid-info {
  //  background: blue; // #c6d9c8; // #b0c1b2;
  //	background: transparent;
  width: 100%;
  padding: 6px;

  padding-right: 35px !important;
  //max-height: 86vh;
  //padding-left: 20px;
}

.testClass {
  background: red;
  color: orange;
  padding: 4px;
}
</style>
